import { PieChart } from 'components/PieChart/PieChart'
import React, { useMemo } from 'react'

interface Datum {
    case_status: string
    count: number
}

interface ChargebacksByStatusProps {
    data: Datum[]
    loading?: boolean
}

export const ChargebacksByStatusPie: React.FC<ChargebacksByStatusProps> = ({
    data,
    loading = false,
}) => {
    const formattedData = useMemo(
        () =>
            data.map((i) => ({
                name: i.case_status,
                value: i.count,
            })),
        [data]
    )

    return (
        <div id="dashboardChargebacksByStatus">
            <PieChart
                data={formattedData}
                loading={loading}
                testId="chargebacksByStatus"
                height={350}
                pieLabelLayout="inside"
            />
        </div>
    )
}
